var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "bonus-slider"
  }, [_c('ViewportToogle', {
    scopedSlots: _vm._u([{
      key: "desktop",
      fn: function () {
        return [_c('BaseRowSlider', {
          attrs: {
            "offset-between-elements": 30,
            "list": _vm.list,
            "overflow": "unset"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function (_ref) {
              var el = _ref.el;
              return [_vm._t("default", null, {
                "el": el
              })];
            }
          }, {
            key: "nav",
            fn: function (_ref2) {
              var prev = _ref2.prev,
                  next = _ref2.next;
              return [_c('button', {
                staticClass: "bonus-slider-btn bonus-slider-btn_prev",
                on: {
                  "click": function ($event) {
                    return prev(1);
                  }
                }
              }), _vm._v(" "), _c('button', {
                staticClass: "bonus-slider-btn bonus-slider-btn_next",
                on: {
                  "click": function ($event) {
                    return next(1);
                  }
                }
              })];
            }
          }], null, true)
        })];
      },
      proxy: true
    }, {
      key: "mobile",
      fn: function () {
        return [_c('BaseRowSlider', {
          attrs: {
            "offset-between-elements": 10,
            "list": _vm.list,
            "overflow": "unset"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function (_ref3) {
              var el = _ref3.el;
              return [_vm._t("default", null, {
                "el": el
              })];
            }
          }], null, true)
        })];
      },
      proxy: true
    }])
  }), _vm._v(" "), _c('div', {
    staticClass: "bonus-slider__layer"
  })], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }